import { style } from '@vanilla-extract/css';
import { themeVars } from '@tundr/theme';

export const sidePanelHeaderClass = style({
  display: 'flex',
  flexDirection: 'column',
  gap: themeVars.space.x4,
});

export const sidePanelHeaderTitleClass = style({
  fontSize: themeVars.font.size.h1,
  marginTop: themeVars.space.x4,
});

export const sidePanelHeaderSubtitleClass = style({
  fontSize: themeVars.font.size.h3,
});
